// extracted by mini-css-extract-plugin
export default {"userIcon-div":"UserIcon_userIcon-div__0q+nr"};